module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- This is a placeholder template, create a unique template per site -->\n<div class="masthead" id="js-masthead">\n	<div class="login-block">\n		<p>You need an NRL Account &\n			make sure it\'s verified</p>\n		';
 if(!IS_PRE_SEASON){ 
__p+='\n		<a href="javascript:void(0)" class="btn js-play">Sign up / Log in</a>\n		';
 } else { 
__p+='\n		<a class="btn" href="http://www.nrl.com/account">Get your NRL account</a>\n		';
 } 
__p+='\n	</div>\n</div>';
}
return __p;
};
